import {
    Component, OnInit, EventEmitter, ElementRef, Input, Output, OnDestroy, OnChanges, SimpleChanges
} from '@angular/core';

declare const $: any;

@Component({
    selector: 'app-popup-datepicker',
    templateUrl: 'popup-datepicker.component.html',
    styleUrls: ['./jquery.timepicker.css' ]
})

export class PopupDatepickerComponent implements OnInit, OnDestroy, OnChanges {
    @Input() selectOption: any = {};
    @Input() selectedValue: string;
    @Input() fromDate: string;
    @Input() fromTime: string;
    @Input() toDate: string;
    @Input() toTime: string;
    @Output() setTimes: EventEmitter<any> = new EventEmitter<any>();

    // 유효성 검사
    isEmptyStartTime: Boolean = false;
    isEmptyEndTime: Boolean = false;
    isInvalidTime: Boolean = false;
    invalidCnt = 0;
    diff: Number;

    expandYN = false;

    options: any = {};

    private el: HTMLElement;

    calendarParams: any = {
        fromDate: '',
        fromTime: '',
        toDate: '',
        toTime: ''
    };

    constructor(el: ElementRef) {
        this.el = el.nativeElement;
    }

    ngOnInit() {

        const _x = this;

        // for Popup
        /*
        this.fromDate = moment().format('YYYY-MM-DD');
        this.fromTime = moment().format('HH:mm');

        this.toDate = moment(this.fromDate + ' ' + this.fromTime).add(this.selectedValue, 'm').format('YYYY-MM-DD');
        this.toTime = moment(this.fromDate + ' ' + this.fromTime).add(this.selectedValue, 'm').format('HH:mm');
        */

        $('input[name="daterangePopup"]').daterangepicker({
            singleDatePicker: true,
            standalone: true,
            autoApply: true,
            locale: {
                format: 'YYYY-MM-DD',
                separator: ' > '
            },
            minDate: moment().add(0, 'day')
        });

        $('input[name="timePicker"]').timepicker({
            'timeFormat': 'H:i',
            'disableTimeRanges': [['00:00', _x.fromTime]],
            'disableTextInput': true, 'selectOnBlur': true, 'step': _x.selectedValue});

        this.updateTimePicker();


    }

    ngOnChanges() {
        // selectedValue 초기화 : 60 min
        $('#mtncPlanDuration').val(this.selectedValue);
        this.updateTimePicker();
    }

    ngOnDestroy() {
        //화면변경시 데이터피커가 계속붇고있어 삭제처리함.
        //div를 강제로 삭제하는 구문이나 추후 daterangepicker가 destroy하는 방법을 찾아야함..
        $('.daterangepicker').remove();
    }

    /** 시간 변경 : for Popup **/
    public setTimeInterval(event) {
        this.setTimes.emit({
            fromDate: $('#from_date2').val(),
            fromTime: $('#from_time2').val(),
            toDate: $('#to_date2').val(),
            toTime: $('#to_time2').val()
        });
        this.expandYN = !this.expandYN;

        // console.log(event);
        const fromDt = $('#from_date2').val();
        const fromTm = $('#from_time2').val();
        this.toDate = moment(fromDt + ' ' + fromTm).add(event, 'm').format('YYYY-MM-DD');
        this.toTime = moment(fromDt + ' ' + fromTm).add(event, 'm').format('HH:mm');
    }

    setCalendarParams() {
        this.calendarParams.fromDate = $('#from_date2').val();
        this.calendarParams.fromTime = $('#from_time2').val();
        this.calendarParams.toDate   = $('#to_date2').val();
        this.calendarParams.toTime   = $('#to_time2').val();
    }

    /* datepicker 유효성 체크 */
    dateValidCheck(): number {
        // 1. 초기화
        this.validCheckInit();
        // 2. 세팅
        this.setCalendarParams();
        // 3. empty 체크
        this.startTimeEmptyCheck();
        this.endTimeEmptyCheck();

        if (this.invalidCnt === 0) {
            // 4. 유효성 체크
            this.dateRangeValidCheck();
        }
        console.log('invalidCnt... : ' + this.invalidCnt);
        return this.invalidCnt;
    }

    /* start time 공백 체크 */
    startTimeEmptyCheck() {
        if (this.calendarParams.fromTime === null || this.calendarParams.fromTime === '') {
            this.isEmptyStartTime = true;
            this.invalidCnt++;
        }
    }

    /* end time 공백 체크 */
    endTimeEmptyCheck() {
        if (this.calendarParams.toTime === null || this.calendarParams.toTime === '') {
            this.isEmptyEndTime = true;
            this.invalidCnt++;
        }
    }

    /* 기간 유효성 체크 */
    dateRangeValidCheck() {
        const startDate = moment(this.calendarParams.fromDate + ' ' + this.calendarParams.fromTime).format('YYYY-MM-DD HH:mm');
        const endDate = moment(this.calendarParams.toDate + ' ' + this.calendarParams.toTime).format('YYYY-MM-DD HH:mm');

        this.diff = moment(endDate, 'YYYY-MM-DD HH:mm').diff(startDate, 'm');

        if (this.diff <= 0) {
            this.isInvalidTime = true;
            this.invalidCnt++;
        }
    }

    /* 유효성값 초기화 */
    validCheckInit() {
        this.invalidCnt = 0;
        this.isEmptyStartTime = false;
        this.isEmptyEndTime = false;
        this.isInvalidTime = false;
        this.diff = 0;
    }

    /* Caller에 Date 값 전송 */
    sendDateParam() {
        this.setTimes.emit(this.calendarParams);
    }

    private updateTimePicker() {

        console.log('fromDate: ' + this.fromDate + 'fromTime: ' + this.fromTime + 'toDate: ' + this.toDate + 'toTime: ' + this.toTime);

    }
}



// WEBPACK FOOTER //
// ./src/app/components/arrow-datepicker/popup-datepicker.component.ts